import React from 'react';
import { Block, BlockBetween, BlockHead, BlockHeadContent, Icon } from '../../components/Component';

const AuthTenantPageError = ({ tenant_info, error_message }) => {
  return (
    <div style={{
      height: tenant_info?.tenant_logo ? "40vh" : "60vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      padding: "20px"
    }}>
      <Block size="lg" style={{
        maxWidth: "500px",
        width: "100%",
        animation: "fadeIn 0.3s ease-out"
      }}>
        <BlockBetween className="center">
          <BlockHead>
            <BlockHeadContent>
              <div className="brand-logo text-center" style={{
                marginBottom: "2rem",
                display: "flex",
                justifyContent: "center",
                width: "100%"
              }}>
                {tenant_info?.tenant_logo && (
                  <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "100%"
                  }}>
                    <img
                      className="logo-custom-img-main_app_loading w-70"
                      src={tenant_info?.tenant_logo}
                      alt="logo-dark"
                      style={{ maxWidth: "100%", height: "auto" }}
                    />
                  </div>
                )}
              </div>

              <div style={{
                backgroundColor: "white",
                borderRadius: "12px",
                padding: "2rem",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
                textAlign: "center",
                border: "1px solid rgba(0,0,0,0.03)"
              }}>
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "1rem"
                }}>
                  <div style={{
                    display: "inline-flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    backgroundColor: "#fff0f0"
                  }}>
                    <Icon
                      name="alert-circle"
                      className="text-danger"
                      style={{
                        fontSize: "32px",
                        color: "#ff4d4f"
                      }}
                    />
                  </div>

                  <h2 style={{
                    color: "#4a5568",
                    fontSize: "1rem",
                    lineHeight: "1.5",
                    margin: 0
                  }}>
                    Oops! Something went wrong
                  </h2>

                  <div style={{
                    maxWidth: "90%",
                    wordBreak: "break-word",
                    textAlign: "center"
                  }}>
                    <p style={{
                      color: "#2d3748",
                      fontSize: "1.125rem",
                      fontWeight: "600",
                      margin: 0,
                      lineHeight: "1.4"
                    }}>
                      {error_message}
                    </p>
                  </div>

                  <div style={{
                    height: "1px",
                    width: "100%",
                    background: "linear-gradient(90deg, transparent, rgba(0,0,0,0.05), transparent)",
                    margin: "1rem 0"
                  }}></div>

                  <p style={{
                    color: "#718096",
                    fontSize: "0.875rem",
                    margin: 0
                  }}>
                    Please try again or contact support if the problem persists.
                  </p>
                </div>
              </div>
            </BlockHeadContent>
          </BlockHead>
        </BlockBetween>
      </Block>

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default AuthTenantPageError;